import {
  computed,
  inject,
  Injectable,
  linkedSignal,
  signal,
} from '@angular/core';
import { TrustApplicationOverview } from '../interfaces/trust-overview.interface';
import { StorageService } from '@shared/services';
import { AgnosticApplicationStatus, StorageKey } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class TrustOverviewStateService {
  private readonly _storageService = inject(StorageService);
  private readonly _overview = signal<TrustApplicationOverview | null>(
    this._storageService.read(StorageKey.trustOverview) ?? null,
  );
  private readonly _trustApplicationId = linkedSignal(
    () => this._overview()?.id ?? null,
  );

  public readonly overview = this._overview.asReadonly();
  public readonly trustApplicationId = this._trustApplicationId.asReadonly();

  public readonly isLoading = signal<boolean>(false);

  public setOverview(overview: TrustApplicationOverview): void {
    this._overview.set(overview);
  }
  public setTrustApplicationId(id: number) {
    this._trustApplicationId.set(id);
  }

  public setIsLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }

  public isStatusNew = computed(() => {
    return this.overview()?.status === AgnosticApplicationStatus.NEW;
  });
}
